module.exports = __webpack_public_path__ + "img/news_active1.8cef8d50.svg";